import { useEffect, useState } from 'react'
import useActiveWeb3React from './useActiveWeb3React'

/* eslint-disable camelcase */
export interface DeBankTvlResponse {
  result: number
}

export const moonPayBaseUrl =
  process.env.REACT_APP_MOONPAY_BASE_URL ||
  'https://buy.onramper.com/?themeName=dark&onlyCryptos=BNB_BSC,BUSD_BSC&amp;containerColor=06334bff&amp;primaryColor=158de8ff&amp;secondaryColor=06334bff&amp;cardColor=000e17ff&amp;primaryTextColor=ffffff&amp;secondaryTextColor=bfbfbfff&amp;borderRadius=1&amp;wgBorderRadius=1&amp;defaultAmount=50&amp;defaultCrypto=BNB_BSC&amp;supportSell=false&amp;supportSwap=false&amp;defaultAddrs=%5Bobject+Object%5D'

  export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://ape-swap-api.herokuapp.com'
 
  const defaultCurrencies = {
  }
  export const useMoonPayUrl = (manualChainId?: number) => {
  const { account, chainId } = useActiveWeb3React()
  const chainIdToUse = manualChainId || chainId
  const defaultCurrency = defaultCurrencies[chainIdToUse] || defaultCurrencies[56]
  const baseMoonPayUrl = `${moonPayBaseUrl}&defaultCurrencyCode=${defaultCurrency}`
  const [url, setUrl] = useState<string>(baseMoonPayUrl)
 
  useEffect(() => {
    const fetchUrl = async () => {
      try {
        const response = await fetch(
          `${apiBaseUrl}/user/sign/${account}?${new URLSearchParams({
            url: baseMoonPayUrl,
          })}`,
        )
        if (response.ok) {
          const text = await response.text()
          setUrl(text)
        } else {
          console.warn('Unable to load signed moonpay url data:', response.statusText)
        }
      } catch (error) {
        console.warn('Unable to load signed moonpay url data:', error)
      }
    }

    if (account) fetchUrl()
  }, [account, baseMoonPayUrl])

  return url
}
export const useGetStats = () => {
  const [data, setData] = useState<DeBankTvlResponse | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://api.bscscan.com/api?module=account&action=balance&address=0xbf3B713827d5DA58E25711e746922b0A6233DE86&apikey=5XY3FPZB96KUQZHKPE5B1FTWPYV95JURIB')
        const responseData: DeBankTvlResponse = await response.json()

        setData(responseData)
      } catch (error) {
        console.error('Unable to fetch data:', error)
      }
    }

    fetchData()
  }, [setData])

  return data
}
